import styled, { css } from 'styled-components';
import { orange, white } from '../../../../style/colors';

const center = css`display: flex; align-items: center; justify-content: center;`;
const inputFocus = css`
  &:focus { border-color: ${orange}; box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1); }
`;

export const Overlay = styled.div`
  position: fixed; inset: 0; background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(4px);
  ${center}; z-index: 2000;
  opacity: ${p => p.isVisible ? 1 : 0}; visibility: ${p => p.isVisible ? 'visible' : 'hidden'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Modal = styled.div`
  background: ${white}; border-radius: 16px; box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%; max-width: 800px; max-height: 90vh; display: flex; flex-direction: column;
  transform: ${p => p.isVisible ? 'scale(1)' : 'scale(0.95)'};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Header = styled.div`
  padding: 20px 24px; border-bottom: 1px solid #e5e7eb;
  display: flex; align-items: center; justify-content: space-between;
`;

export const Title = styled.h2`
  margin: 0; font-size: 20px; font-weight: 700; color: #111827; ${center}; gap: 10px;
  i { color: ${orange}; font-size: 24px; }
`;

export const CloseButton = styled.button`
  background: none; border: none; cursor: pointer; padding: 8px; border-radius: 8px;
  color: #6b7280; transition: all 0.2s;
  &:hover { background: #f3f4f6; color: #111827; }
  i { font-size: 24px; }
`;

export const Content = styled.div`padding: 24px; flex: 1; overflow-y: auto;`;

export const Section = styled.div`
  margin-bottom: 24px;
  &:last-child { margin-bottom: 0; }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 12px 0; font-size: 14px; font-weight: 600; color: #374151;
  text-transform: uppercase; letter-spacing: 0.5px;
`;

export const InputGroup = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 12px;
`;

export const InputWrapper = styled.div`display: flex; flex-direction: column; gap: 6px;`;
export const Label = styled.label`font-size: 13px; font-weight: 500; color: #6b7280;`;

export const Input = styled.input`
  padding: 10px 12px; border: 1.5px solid #e5e7eb; border-radius: 8px;
  font-size: 14px; outline: none; transition: all 0.2s;
  ${inputFocus}
  &::placeholder { color: #9ca3af; }
`;

export const Select = styled.select`
  padding: 10px 12px; border: 1.5px solid #e5e7eb; border-radius: 8px;
  font-size: 14px; outline: none; transition: all 0.2s; background: ${white}; cursor: pointer;
  ${inputFocus}
`;

export const CheckboxGroup = styled.div`display: flex; flex-wrap: wrap; gap: 12px;`;

export const CheckboxLabel = styled.label`
  ${center}; gap: 8px; font-size: 13px; color: #374151; cursor: pointer;
  padding: 8px 12px; border-radius: 8px; transition: all 0.2s;
  border: 1.5px solid ${p => p.checked ? orange : '#e5e7eb'};
  background: ${p => p.checked ? '#fff5f0' : white};
  &:hover { border-color: ${orange}; }
  input { cursor: pointer; }
`;

export const QueryPreview = styled.div`
  background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 16px; margin-top: 16px;
`;

export const QueryTitle = styled.div`
  font-size: 12px; font-weight: 600; color: #6b7280; text-transform: uppercase;
  letter-spacing: 0.5px; margin-bottom: 8px;
`;

export const QueryText = styled.div`
  font-family: monospace; font-size: 13px; color: #374151; line-height: 1.6; word-wrap: break-word;
`;

export const Footer = styled.div`
  padding: 16px 24px; border-top: 1px solid #e5e7eb;
  display: flex; gap: 12px; justify-content: space-between;
`;

export const Button = styled.button`
  padding: 10px 20px; border-radius: 8px; font-size: 14px; font-weight: 600;
  cursor: pointer; transition: all 0.2s; ${center}; gap: 8px; border: none;
  i { font-size: 18px; }
`;

export const ClearButton = styled(Button)`
  background: ${white}; border: 1.5px solid #fecaca; color: #dc2626;
  &:hover { background: #fef2f2; border-color: #f87171; }
`;

export const CancelButton = styled(Button)`
  background: ${white}; border: 1.5px solid #e5e7eb; color: #374151;
  &:hover { background: #f9fafb; border-color: #d1d5db; }
`;

export const SearchButton = styled(Button)`
  background: linear-gradient(135deg, ${orange} 0%, #ff8c00 100%); color: ${white};
  box-shadow: 0 2px 8px rgba(255, 165, 0, 0.25);
  &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(255, 165, 0, 0.35); }
  &:active { transform: translateY(0); }
`;
